

import React, { useState, useEffect } from 'react';
import Layout from './layouts/layout';

function IndexOp() {
    const [ops, setOps] = useState([]);

    useEffect(() => {
        fetch('/api/ordens-producao/')
            .then(response => response.json())
            .then(data => setOps(data))
            .catch(error => console.error('Erro ao buscar OPs:', error));
    }, []);
    return (
        <Layout>
            <div className="container mt-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2>Dashboard Operacional</h2>
                    <button className="btn btn-primary">Criar OP</button>
                </div>
                <div className="row">
                    <div className="col-md-4 mb-4">
                        <div className="card text-white bg-primary h-100">
                            <div className="card-body">
                                <div className="card-title">
                                    <i className="pi pi-users" style={{ fontSize: '2rem' }}></i> Colaboradores
                                </div>
                                <h3>150</h3>
                                <p>Total de colaboradores ativos</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mb-4">
                        <div className="card text-white bg-success h-100">
                            <div className="card-body">
                                <div className="card-title">
                                    <i className="pi pi-clock" style={{ fontSize: '2rem' }}></i> Horas Trabalhadas
                                </div>
                                <h3>1.240h</h3>
                                <p>Horas totais este mês</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mb-4">
                        <div className="card text-white bg-warning h-100">
                            <div className="card-body">
                                <div className="card-title">
                                    <i className="pi pi-envelope" style={{ fontSize: '2rem' }}></i> Mensagens
                                </div>
                                <h3>23</h3>
                                <p>Mensagens não lidas</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Seção de OPs Criadas */}
                <div className="row mt-4">
                    <div className="col-12 mb-3">
                        <h3>OPs Criadas</h3>
                    </div>
                    {ops.map(op => (
                        <div className="col-md-4 mb-4" key={op.id}>
                            <div className="card h-100">
                                <div className="card-body">
                                    <h5 className="card-title">OP {op.id} - {op.artigo_phc}</h5>
                                    <p className="card-text">Tipo Saco: {op.tipo_saco.nome}</p>
                                    <p className="card-text">Tamanho: {op.tamanho.nome}</p>
                                    <p className="card-text">Impressão: {op.tipo_impressao.nome}</p>
                                    <p className="card-text">Criada em: {new Date(op.data_criacao).toLocaleDateString()}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Seção de Alertas */}
                <div className="row mt-4">
                    <div className="col-12 mb-3">
                        <h3>Alertas</h3>
                    </div>
                    <div className="col-md-4 mb-4">
                        <div className="card border-danger h-100">
                            <div className="card-body">
                                <h5 className="card-title">Alerta #1</h5>
                                <p className="card-text">Descrição do alerta.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mb-4">
                        <div className="card border-warning h-100">
                            <div className="card-body">
                                <h5 className="card-title">Alerta #2</h5>
                                <p className="card-text">Descrição do alerta.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mb-4">
                        <div className="card border-info h-100">
                            <div className="card-body">
                                <h5 className="card-title">Alerta #3</h5>
                                <p className="card-text">Descrição do alerta.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8">
                        <div className="card mb-4">
                            <div className="card-header">Pedidos Recentes</div>
                            <div className="card-body">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Tipo</th>
                                            <th>Status</th>
                                            <th>Data</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>Férias</td>
                                            <td>Pendente</td>
                                            <td>01/06/2025</td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>Falta</td>
                                            <td>Aprovado</td>
                                            <td>30/05/2025</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>Requisição</td>
                                            <td>Em progresso</td>
                                            <td>28/05/2025</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card mb-4">
                            <div className="card-header">Notificações</div>
                            <div className="card-body">
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item">Você tem 3 pedidos pendentes</li>
                                    <li className="list-group-item">Relatório mensal disponível</li>
                                    <li className="list-group-item">2 novos comentários</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default IndexOp;